import { useTranslation } from "react-i18next";
import { useClearCartMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

/**
 * A custom hook to encapsulate the logic for clearing the entire cart.
 * Typically used after a successful off-site payment (like Iyzico) redirection.
 */
export const useClearCart = () => {
  const { t } = useTranslation();
  const [clearCartMutation, result] = useClearCartMutation();

  const { trigger: handleClearCart, isLoading: isClearing } =
    useMutationWithFeedback({
      mutation: [clearCartMutation, result],
      // We usually run this silently on page load, so no loading toast by default.
      // If manual trigger is needed, these messages will appear.
      loadingMessage: undefined,
      successMessage: null, // Silent success
      errorMessages: {
        default: t("feedback.cart.clearError", "Could not clear cart items."),
      },
    });

  return {
    handleClearCart,
    isClearing,
  };
};
